import { calcInterestAmt } from "../../../objects/CommonUse/calc_interest_amt";
import roundAndReturnString from "../../../objects/CommonUse/round_and_return_string";

export const applyInterestToCDList = (intRate, CDList) => {
    let totalIntAmt = 0;
    for (let i=0; i<CDList.length; i++){
        const CDAmt = +CDList[i].amount + +CDList[i].intAmt;
        const intAmt = calcInterestAmt(CDAmt, intRate, "month");
        const newIntAmt = (+CDList[i].intAmt + +intAmt);
        CDList[i].intAmt = roundAndReturnString(newIntAmt, 2);
        totalIntAmt += +intAmt;
    }
    totalIntAmt = totalIntAmt.toFixed(2);
    return totalIntAmt;
}
export default applyInterestToCDList;